import React, {ComponentType, FC} from 'react';
// eslint-disable-next-line no-restricted-imports
import {ReactReduxContext, TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';
import {Subtract} from 'utility-types';

import {AppState} from '../store/appState';
import {AppStore} from '../store/appStore';

export const useAppDispatch = () => useDispatch<AppStore['dispatch']>();

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;

export interface StoreProps {
  store: AppStore;
}

export function withStore<T extends StoreProps>(Component: ComponentType<T>): FC<Subtract<T, StoreProps>> {
  return function (props) {
    return (
      <ReactReduxContext.Consumer>
        {(context) => <Component {...(props as any)} store={context.store} />}
      </ReactReduxContext.Consumer>
    );
  };
}
